import * as React from "react";
const SvgFiRrDongSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 23c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1M6 14c0-3.31 2.69-6 6-6 1.54 0 2.94.58 4 1.53V4h-4c-.55 0-1-.45-1-1s.45-1 1-1h4V1c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1v15c0 .55-.45 1-1 1s-1-.45-1-1v-.53A5.97 5.97 0 0 1 12 20c-3.31 0-6-2.69-6-6m2 0c0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4-4 1.79-4 4"
    />
  </svg>
);
export default SvgFiRrDongSign;
